import { withProps } from 'recompose';
import { Image } from 'components/core/Image';
import twentyFourHourAccessImage from 'assets/images/amenities/24-hour-access.png';
import climateControlImage from 'assets/images/amenities/climate-control.png';
import driveUpAccessImage from 'assets/images/amenities/drive-up-access.png';
import locksImage from 'assets/images/amenities/locks.png';
import securityImage from 'assets/images/amenities/security.png';
import truckRentalImage from 'assets/images/amenities/truck-rental.png';

const amenityImages = {
	twentyFourHours: twentyFourHourAccessImage,
	climateControlled: climateControlImage,
	driveUpAccess: driveUpAccessImage,
	locks: locksImage,
	security: securityImage,
	truckRental: truckRentalImage,
};

export const enhance = withProps(({ amenity }) => ({
	src: amenityImages[amenity],
	className: 'amenity-icon',
}));

export default enhance(Image);
